import _ from 'lodash'
import { Glossary, Category } from '@/types/glossary'

export default function getRelatedWords(
  definition: Glossary,
  AllGlossary: Glossary[],
  categoriesMap: { [key: string]: Category }
) {
  const relatedWord: Glossary[] = []
  const definitionCategories = definition.categories
    .filter(
      (x) =>
        categoriesMap[x]?.slug !== 'glossary-en' &&
        categoriesMap[x]?.slug !== 'trending-glossary-en'
    )
    .map((x) => categoriesMap[x]?.slug)

  AllGlossary.forEach((word) => {
    if (
      !word.categories.length ||
      !definitionCategories.length ||
      word.slug === definition.slug
    )
      return
    const curWordCategories = word.categories
      .filter(
        (x) =>
          categoriesMap[x]?.slug !== 'glossary-en' &&
          categoriesMap[x]?.slug !== 'trending-glossary-en'
      )
      .map((x) => categoriesMap[x]?.slug)
    const intersection = _.intersection(definitionCategories, curWordCategories)
    if (intersection.length) relatedWord.push(word)
  })

  return relatedWord
}
